<template>
  <a-modal title="发送消息" :visible="true" @ok="send" @cancel="cancel">
    <a-form  :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
    <a-form-item label="昵称">
      {{form.nickname}}
    </a-form-item>
    <a-form-item label="内容">
      <a-textarea
      v-model="form.content"
      :auto-size="{ minRows: 3, maxRows: 5 }"
    />
    </a-form-item>
    </a-form>
  </a-modal>
</template>

<style lang='scss' scord>
</style>

<script>
export default {
  props: ['msg'],
  data() {
    return {
      form: {}
    };
  },

  created() {
    this.form = { ...this.msg }
  },

  methods: {
    async send() {
      const r = await this.$axios.post('/msg/send', this.form);
      if(r.status == 1){
        this.$emit('callback', 1)
      }
    },
    cancel() {
      this.$emit('callback', 0)
    },
  },
};
</script>